import {Modal} from "react-bootstrap";
import { ADD_TIME_MODAL_SUBMIT_TEXT, ADD_TIME_MODAL_TEXT, ADD_TIME_TEXT, MODAL, POLL_TIME_LIMIT_MODAL_CANCEL, TEXTBOX } from "../../utils/constants";
import YuJaButton from "../standardization/YuJaButton";
import "./modal.css";
import { useState } from "react";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import loadingGif from "../../images/LoadingAnimation.gif";
import {Button} from "@base-ui/react/button";

export default function AddPollTimeModal({ show, setShow, handleSubmit, AddTimeOptions, AddTimeValues, isLoading=false}) {
    const [selectedTime, setSelectedTime] = useState(""); 

    const numberDivs = AddTimeOptions.map((option, index) => (
        <Button className={`${ index === selectedTime ? "AddTimeOptionsActivated": "AddTimeOptions"}`} key={index} onClick={()=> {setSelectedTime(index)}}>+{option}</Button>
      ));

    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <ModalClose onClick={() => setShow(false)} className="modal-close" style={{width:24, height:24}}/>
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title
                    className="modal-title"
                    id="contained-modal-title-vcenter"
                    tabIndex={0}
                    aria-label={"Set Poll Time Limit" + MODAL}
                    role={TEXTBOX}
                >
                    {ADD_TIME_TEXT}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ fontWeight: 700, fontSize: 14, lineHeight: 1.6, color: "#000000", marginBottom: "15px", marginTop: "-10px"}}> {ADD_TIME_MODAL_TEXT} </div>
                <div className="AddTimeOptionsContainer">

                    {numberDivs}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <YuJaButton
                    style={{width: 80, height: 36, display: "flex", justifyContent: "center", alignItems: "center"}}
                    type="secondary"
                    onClick={() => setShow(false)}
                >{POLL_TIME_LIMIT_MODAL_CANCEL}</YuJaButton>
                <YuJaButton
                    disabled={!!isLoading}
                    style={{width: 80, height: 36, display: "flex", justifyContent: "center", alignItems: "center" }}
                    onClick={() => handleSubmit(AddTimeValues, selectedTime)}
                >
                    {!!isLoading
                        ? <img src={loadingGif} alt={"loading..."} style={{height: 31}}/>
                        : <span style={{height: 31, display: "flex", alignItems: "center"}}>{ADD_TIME_MODAL_SUBMIT_TEXT}</span>
                    }
                </YuJaButton>
            </Modal.Footer>
        </Modal>
    );
}